export default "__VITE_ASSET__d7634808__"